import { APP_CONSTANTS } from "../../core/config/appConstants";
import Container from "../../shared/components/Container/Container";
import useTitle from "../../core/hooks/useTitle";

// This page gets displayed if session gets expired or link is invalid
const SessionExpired = () => {
	useTitle("Link abgelaufen doer ungültigt");

	const buttons = [
		{
			label: "Zu Telekom.de",
			variant: "primary",
			onClick: () =>
				(window.location.href =
					APP_CONSTANTS.LINK.TELEKOM),
			size: "small",
			tabIndex: 3,
			ariaLabel: "Link zu Telekom.de"
		}
	];
	const icons = [
		{
			name: "error-type-standard",
			size: 64,
			color: "var(--color-error)"
		}
	];

	return (
		<Container
			title="Link abgelaufen oder ungültig"
			description={`Der von Ihnen aufgerufene Link ist entweder ungültig oder bereits abgelaufen.
Bitte starten Sie den Verifikationsprozess erneut, indem Sie den aktuellen Link aus Ihrer Bestätigungsmail verwenden.`}
			buttons={buttons}
			icon={icons[0]}
		></Container>
	);
};

export default SessionExpired;
